import { AmzonImg } from './common'
import classnames from 'classnames';

const { chunk } = lodash;
const { Flex, FlexItem,FlexBlock, Button, Modal, Spinner } = wp.components;
const { useState, useEffect } = wp.element;
const { __ } = wp.i18n;
const { apiFetch } = wp;

export const MdlImagePickerNew = ({ image, prodPos, updateImages, asin, size} = props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (open) {
      setLoading(true);
      apiFetch({ path: "/i2-azon/v1/images/" + asin })
        .then((data) => {
          setImages(JSON.parse(data));
          setLoading(false);
        });
    }
  }, [open]);

  return (<figure>
    <figure style={{ position: "relative" }} >
      <Button icon="images-alt2" isPrimary size="24" aria-label="remove" onClick={() => setOpen(true)} style={{ position: "absolute", top: '15px', left: '15px' }}></Button>
      {image && <AmzonImg imageUrl={image.URL} ext={image.EXT? image.EXT : "jpg"} size={size}></AmzonImg>}
    </figure>
    { open ?
      <Modal open={open} title={__("Select Image", 'themesfirst')} onRequestClose={obj => setOpen(false)} aria-labelledby="form-dialog-title">
        <div style={{ minHeight: '400px' }}>
          {loading && <Flex justify="center"><FlexBlock style={{minHeight:'100px', textAlign:'center'}}><Spinner /></FlexBlock></Flex>}
          {images.length > 0 && chunk(images, 3).map((imgs) => {
            return <Flex justify="center">
              {imgs.map((img) => <FlexItem style={{ maxWidth: '33%' }}>
                <AmzonImg
                  onClick={() => updateImages(prodPos, img)}
                  className={ classnames('tf-mdl-image', {'tf-mdl-image-active': image && img.URL == image.URL })}
                  imageUrl={img.URL} size="400" 
									ext={img.EXT? img.EXT : "jpg"}/>
              </FlexItem>
              )}
            </Flex>
          }
          )}

      </div>
      </Modal> : null}
  </figure>)
}
